import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from './../Navbar';
import logo from './../hotel_logo.png';
import { collection, onSnapshot, query, orderBy, getDocs } from 'firebase/firestore';
import { db } from './../../firebase/Config';
import { useEffect,  useState} from 'react';
import Header from '../Header';
import { useAuthContext } from './../../hooks/useAuthContext';
//import Bookingform from './Bookingform';
//import Userviews from './Userviews';


const Userdetails = () => {
    const [views, setViews] = useState([]);
    const {user,isAuthReady} = useAuthContext()
    const usersCollectionRef = collection(db,"booking");
    const queryRef = query(usersCollectionRef, orderBy("createdAt", "desc"))
    useEffect(() => {
      const getUsers = async () => {
        const data = await getDocs(queryRef);
        setViews(data.docs.map((doc) => ({ ...doc.data(), id:doc.id})))
      };
      getUsers();
    },[]);


  return (
    <div>
    <Header />
      <section class="breadcrumb-area overlay-dark-2 bg-3">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="breadcrumb-text text-center">
                    <h2>Room Booking list</h2>
                    <p>A room booking menu list details in maskva</p>
                    <div class="breadcrumb-bar">
                        <ul class="breadcrumb">
                        <li><Link to="/adminpanels">Price List</Link></li>
                        <li><Link to="/benqdataview">ROOM BOOKING LIST</Link></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
    <div className="container-fluid outer pt-5 table-responsive" >
<table class="table table-dark table-bordered table-striped">
  <thead>
    <tr className="text-center">
      <th scope="col">Id</th>
      <th scope="col">Room Type</th>
      <th scope="col">Name</th>
      <th scope="col">Email</th>
      <th scope="col">Phone Number</th>
      <th scope="col">Message</th>
      <th scope="col">Expectation Time</th>
      <th scope="col">Adult</th>
      <th scope="col">Child</th>
      <th scope="col">First Age</th>
      <th scope="col">Food</th>
      <th scope="col">Bed</th>
      <th scope="col">Price</th>
      <th scope="col">CGST Tax</th>
      <th scope="col">SGST Tax</th>
      <th scope="col">Tax</th>
      <th scope="col">Discount</th>
      <th scope="col">Total Price</th>
      <th scope="col">PaymentID</th>
      <th scope="col">Start Date</th>
      <th scope="col">End Date</th>
      <th scope="col">Created At</th>

      
    </tr>
  </thead>
    {
        views.map((view) => {
          {
            { if (user.uid === "xxlHP783TtRg1NE0Tx88wcMzT6v2") {
          return (
            
          
  <tbody>
    <tr>
      
      <td>{view.userId}</td>
      <td>{view.RoomType}</td>
      <td>{view.Name}</td>
      <td>{view.Email}</td>
      <td>{view.PhoneNumber}</td>
      <td>{view.Message}</td>
      <td>{view.ExpectationTime}</td>
      <td>{view.Adult}</td>
      <td>{view.Child}</td>
      <td>{view.FirstAge}</td>
      <td>{view.Food}</td>
      <td>{view.Bed}</td>
      <td>{view.Price}</td>
      <td>{view.CgstTax}</td>
      <td>{view.SGSTTax}</td>
      <td>{view.Tax}</td>
      <td>{view.Discount}</td>
      <td>{view.TotalPrice}</td>
      <td>{view.paymentid}</td>
      <td>{view.Startsdate.toDate().toString()}</td>
      <td>{view.EndsDate.toDate().toString()}</td>
      <td>{view.createdAt.toDate().toString()}</td>
      
      

      
      
    </tr>
    
  </tbody>

            
            
            
              
           
          )
        }
        else if (user.uid === view.userId) {
            return (
              
            
    <tbody>
      <tr>
        
        <td>-</td>
        <td>{view.Name}</td>
        <td>{view.Email}</td>
        <td>{view.PhoneNumber}</td>
        <td>{view.Message}</td>
        <td>{view.ExpectationTime}</td>
        <td>{view.Adult}</td>
        <td>{view.Child}</td>
        <td>{view.FirstAge}</td>
        <td>{view.Food}</td>
        <td>{view.Bed}</td>
        <td>{view.Price}</td>
        <td>{view.CgstTax}</td>
        <td>{view.SGSTTax}</td>
        <td>{view.Tax}</td>
        <td>{view.Discount}</td>
        <td>{view.TotalPrice}</td>
        <td>{view.paymentid}</td>
        <td>{view.Startsdate.toDate().toString()}</td>
        <td>{view.EndsDate.toDate().toString()}</td>
        <td>{view.createdAt.toDate().toString()}</td>
        
        
  
        
        
      </tr>
      
    </tbody>
  
              
              
              
                
             
            )
          }
    }
          }
        })
       }
       </table>
       </div>
       <footer className="footer-area pt-5 mt-5">
      
      <div className="footer-widget-area bg-dark">
        <div className="container">
          <div className="row mb-n60">
            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12 mb-60">
              <div className="single-footer-widget">
                <div className="footer-logo">
                  <Link to="#"><img src={logo} alt="Oestin" style={{ width: "14rem" }} /></Link>
                </div>
                <p>
                Moskva Hotel is a 3-star property located 15 kilometers from Madurai Airport, 900 meters from Madurai Junction Railway Station, and one kilometer from Periyar Bus Stand.
                </p>
                <div className="social-icons">
                  <Link to="#"><i className="zmdi zmdi-facebook"></i></Link>
                  <Link to="#"><i className="zmdi zmdi-instagram"></i></Link>
                  <Link to="#"><i className="zmdi zmdi-rss"></i></Link>
                  <Link to="#"><i className="zmdi zmdi-twitter"></i></Link>
                  <Link to="#"><i className="zmdi zmdi-pinterest"></i></Link>
                </div>
              </div>
            </div>
            <div className="col-xl-3 offset-lg-1 col-lg-4  col-md-6 col-sm-6 col-12 mb-60">
              <div className="single-footer-widget">
                <h3>contact us</h3>
                <div className="c-info">
                  <span><i className="zmdi zmdi-pin"></i></span>
                  <span>57, Tamilsangam Road, Madurai,  <br />Tamil Nadu 625001</span>
                </div>
                <div className="c-info">
                  <span><i className="zmdi zmdi-email"></i></span>
                  <span>info@moskvahotel.in<br />info@moskvahotel.in</span>
                </div>
                <div className="c-info">
                  <span><i className="zmdi zmdi-phone"></i></span>
                  <span>+91-8489914838<br />+91-452 4219063</span>
                </div>
                <div style={{display:"flex"}}>
                <div className="footer-logo">
                    <a href="https://play.google.com/store/games?hl=en&gl=US&pli=1"><img src="assets/img/moskva-photos/small/plays.png" alt="Oestin" style={{ width: "10rem" }} /></a>
                  </div>
                  <div className="footer-logo" style={{paddingLeft:"5px"}}>
                    <a href="https://www.apple.com/in/app-store/"><img src="assets/img/moskva-photos/small/play.png" alt="Oestin" style={{ width: "10rem" }} /></a>
                  </div>
                  </div>
              </div>
            </div>
            <div className="col-xl-2 col-lg-3 col-md-6 col-sm-6 col-12 mb-60">
              <div className="single-footer-widget">
                <h3>quick links</h3>
                <ul className="footer-list">
                <li><Link to="/">Home</Link></li>
                <li><Link to="/rooms">Rooms</Link></li>
                <li><Link to="/benquetmenu">Banquets Menu</Link></li>
                <li><Link to="/about">About</Link></li>
                <li><Link to="/resturants">Resturants</Link></li>
                <li><Link to="/bars">Bar</Link></li>
                </ul>
              </div>
            </div>
            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12 mb-60">
              <div className="single-footer-widget">
                <h3>collections</h3>
                <div className="instagram-image">
                  <div className="footer-img">
                    <Link to="#"><img src="assets/img/moskva-photos/small/DSC0962.jpg" alt=""/></Link>
                  </div>
                  <div className="footer-img">
                    <Link to="#"><img src="assets/img/moskva-photos/small/DSC0980.jpg" alt=""/></Link>
                  </div>
                  <div className="footer-img">
                    <Link to="#"><img src="assets/img/moskva-photos/small/DSC1004.jpg" alt="" /></Link>
                  </div>
                  <div className="footer-img">
                    <Link to="#" ><img src="assets/img/moskva-photos/small/DSC1063.jpg" alt="" /></Link>
                  </div>
                  <div className="footer-img">
                    <Link to="#"><img src="assets/img/moskva-photos/small/DSC1071.jpg" alt="" /></Link>
                  </div>
                  <div className="footer-img">
                    <Link to="#" ><img src="assets/img/moskva-photos/small/DSC1092.jpg" alt="" /></Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='text-center'> 
        <p className="designFont">© 2023 MOSKVA All rights reserved. Designed By <a className="designFont" href="https://jofinity.com/">JOFINITY</a></p>
        </div>
      </div>
      
      
     
    </footer>
    </div>
  )
}

export default Userdetails